import { IsDefined } from "class-validator";

// TODO: Change interface and add class validator decorator.
export class OpenNewTableRequestDto {
  merchantSaleUnitId: number;
  covers: number;
  // TODO (bole): Remove in the future PR, when transition from customerId to posDeviceId is stabilized.
  customerId: number;
  @IsDefined()
  operatorEmployeeId?: number;
  @IsDefined()
  posDeviceId: number;
}
